import React from "react";
import constants from "../constants";

export default function MenuSvgIcon(Props) {
  return Props.menuId === constants.MENU_ICON.BATCHES ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className="menuSvgIconForBatches"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#667085"
        d="M13.75 16.1905C14.1812 16.0207 14.599 15.8188 15 15.5866V18.7499C15 18.9157 14.9342 19.0746 14.817 19.1918C14.6998 19.309 14.5408 19.3749 14.375 19.3749C14.2093 19.3749 14.0503 19.309 13.9331 19.1918C13.8159 19.0746 13.75 18.9157 13.75 18.7499V16.1905ZM14.6688 9.28193L10.2938 6.94833C10.1478 6.87378 9.97842 6.85954 9.82206 6.9087C9.6657 6.95786 9.53491 7.06647 9.45786 7.21114C9.38081 7.35581 9.36368 7.52495 9.41015 7.68213C9.45662 7.83931 9.56297 7.97194 9.7063 8.05146L13.3594 9.9999L14.6875 9.29208L14.6688 9.28193ZM19.6688 6.94833L10.2938 1.94833C10.2034 1.90018 10.1025 1.875 10 1.875C9.8976 1.875 9.79673 1.90018 9.7063 1.94833L0.331299 6.94833C0.231302 7.00163 0.147674 7.0811 0.0893613 7.17825C0.0310483 7.27541 0.000244141 7.38659 0.000244141 7.4999C0.000244141 7.61321 0.0310483 7.72439 0.0893613 7.82154C0.147674 7.91869 0.231302 7.99817 0.331299 8.05146L2.50005 9.20849V12.9913C2.4994 13.2983 2.61238 13.5947 2.81724 13.8233C3.84067 14.9632 6.13364 16.8749 10 16.8749C11.282 16.8855 12.5544 16.6533 13.75 16.1905V10.2085L13.3594 9.9999L10 11.7913L3.42427 8.28115L1.95317 7.4999L10 3.20849L18.0469 7.4999L16.5797 8.28115H16.575L14.6875 9.29208C14.7826 9.34695 14.8615 9.42587 14.9163 9.52091C14.9712 9.61595 15.0001 9.72376 15 9.83349V15.5866C15.8151 15.1161 16.5515 14.5212 17.1829 13.8233C17.3877 13.5947 17.5007 13.2983 17.5 12.9913V9.20849L19.6688 8.05146C19.7688 7.99817 19.8524 7.91869 19.9107 7.82154C19.969 7.72439 19.9999 7.61321 19.9999 7.4999C19.9999 7.38659 19.969 7.27541 19.9107 7.17825C19.8524 7.0811 19.7688 7.00163 19.6688 6.94833Z"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.CODING_CHALLENGE ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 6.875L1.25 10L5 13.125"
      />
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 6.875L18.75 10L15 13.125"
      />
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.5 3.125L7.5 16.875"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.JOBS ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.875 5H3.125C2.77982 5 2.5 5.27982 2.5 5.625V15.625C2.5 15.9702 2.77982 16.25 3.125 16.25H16.875C17.2202 16.25 17.5 15.9702 17.5 15.625V5.625C17.5 5.27982 17.2202 5 16.875 5Z"
      />
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.125 5V3.75C13.125 3.41848 12.9933 3.10054 12.7589 2.86612C12.5245 2.6317 12.2065 2.5 11.875 2.5H8.125C7.79348 2.5 7.47554 2.6317 7.24112 2.86612C7.0067 3.10054 6.875 3.41848 6.875 3.75V5"
      />
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.5 9.24219C15.2208 10.5609 12.6333 11.2534 10 11.2492C7.36684 11.2534 4.77939 10.5613 2.5 9.24297"
      />
      <path
        stroke="#667085"
        strokeWidth="1.4"
        d="M8.75 8.75H11.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.DISCUSSION ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.59219 11.25L2.5 13.75V3.75C2.5 3.58424 2.56585 3.42527 2.68306 3.30806C2.80027 3.19085 2.95924 3.125 3.125 3.125H13.125C13.2908 3.125 13.4497 3.19085 13.5669 3.30806C13.6842 3.42527 13.75 3.58424 13.75 3.75V10.625C13.75 10.7908 13.6842 10.9497 13.5669 11.0669C13.4497 11.1842 13.2908 11.25 13.125 11.25H5.59219Z"
      />
      <path
        stroke="#667085"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.25 11.25V14.375C6.25 14.5408 6.31585 14.6997 6.43306 14.8169C6.55027 14.9342 6.70924 15 6.875 15H14.4078L17.5 17.5V7.5C17.5 7.33424 17.4342 7.17527 17.3169 7.05806C17.1997 6.94085 17.0408 6.875 16.875 6.875H13.75"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.HACKATHON ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className="menuSvgIconForHackathon"
    >
      <g clip-path="url(#clip0_8934_16248)">
        <path
          fill="#667085"
          d="M6.38879 14.2363V15.9029H13.6111V14.2363H6.38879Z"
        />
        <path
          fill="#667085"
          d="M9.1667 11.7368C9.1667 11.5832 9.04248 11.459 8.8889 11.459C8.76631 11.459 8.66553 11.5394 8.62868 11.6498L8.6253 11.6488L8.13312 13.1256H6.66672C6.51314 13.1256 6.38892 13.2499 6.38892 13.4034C6.38892 13.557 6.51313 13.6812 6.66672 13.6812H8.53355L9.15237 11.8249L9.14898 11.8237C9.15875 11.7961 9.16675 11.7677 9.16675 11.7368L9.1667 11.7368Z"
        />
        <path
          fill="#667085"
          d="M7.22212 11.4592H4.82912L4.12854 9.54238L4.12476 9.54382C4.01858 9.20598 3.70653 8.95898 3.33336 8.95898C3.19938 8.95898 3.07438 8.99381 2.96214 9.05L2.96071 9.0472C1.05138 10.0018 -0.00012207 12.141 -0.00012207 15.0704C-0.00012207 15.5306 0.372861 15.9036 0.833278 15.9036H3.33328V18.6814C3.33328 19.1418 3.70626 19.5148 4.16668 19.5148C4.6271 19.5148 4.99988 19.1415 4.99988 18.6813V15.0703C4.99988 14.6099 4.62689 14.2369 4.16648 14.2369L1.70181 14.2369C1.80298 13.0391 2.15663 11.7469 3.09439 10.9457L3.94739 12.2631L3.94941 12.2621C4.04082 12.4441 4.22701 12.5703 4.4444 12.5703H7.22223C7.529 12.5703 7.77763 12.3215 7.77763 12.0147C7.77763 11.7079 7.5288 11.4591 7.22203 11.4591L7.22212 11.4592Z"
        />
        <path
          fill="#667085"
          d="M6.80566 8.40234C6.80566 9.09271 6.24603 9.65234 5.55566 9.65234C4.8653 9.65234 4.30566 9.09271 4.30566 8.40234C4.30566 7.71204 4.8653 7.15234 5.55566 7.15234C6.24603 7.15234 6.80566 7.71204 6.80566 8.40234Z"
        />
        <path
          fill="#667085"
          d="M13.3333 13.1256H11.8667L11.3745 11.6488L11.3713 11.6498C11.3344 11.5394 11.2337 11.459 11.1109 11.459C10.9574 11.459 10.8331 11.5832 10.8331 11.7368C10.8331 11.7676 10.8411 11.796 10.8507 11.8236L10.8473 11.8247L11.4661 13.6811H13.3331C13.4867 13.6811 13.6109 13.5569 13.6109 13.4033C13.6109 13.2498 13.4869 13.1256 13.3333 13.1256L13.3333 13.1256Z"
        />
        <path
          fill="#667085"
          d="M15.6947 8.40234C15.6947 9.09271 15.1351 9.65234 14.4447 9.65234C13.7543 9.65234 13.1947 9.09271 13.1947 8.40234C13.1947 7.71204 13.7543 7.15234 14.4447 7.15234C15.1351 7.15234 15.6947 7.71204 15.6947 8.40234Z"
        />
        <path
          fill="#667085"
          d="M17.04 9.0472L17.0386 9.05C16.9262 8.99381 16.801 8.95898 16.6672 8.95898C16.2944 8.95898 15.982 9.2058 15.876 9.54382L15.872 9.54239L15.1714 11.4592H12.7784C12.4717 11.4592 12.223 11.7078 12.223 12.0146C12.223 12.3214 12.4716 12.5702 12.7784 12.5702H15.5563C15.7736 12.5702 15.96 12.444 16.0514 12.262L16.0535 12.263L16.9066 10.9456C17.8443 11.7468 18.1979 13.0391 18.299 14.2368H15.834C15.3736 14.2368 15.0006 14.6098 15.0006 15.0702V18.6812C15.0006 19.1416 15.3736 19.5146 15.834 19.5146C16.2944 19.5146 16.6672 19.1416 16.6672 18.6812V15.9035H19.1672C19.6276 15.9035 20.0006 15.5305 20.0006 15.0703C20.0006 12.141 18.9492 10.0018 17.04 9.04715L17.04 9.0472Z"
        />
        <path
          fill="#667085"
          d="M10 6.31983C8.39164 6.31983 7.08337 5.01143 7.08337 3.40316C7.08337 1.79496 8.39157 0.486328 10 0.486328C11.6085 0.486328 12.9167 1.79473 12.9167 3.40299C12.9167 5.0112 11.6085 6.31983 10 6.31983ZM10 1.04199C8.69822 1.04199 7.63887 2.10098 7.63887 3.40299C7.63887 4.70495 8.69824 5.76416 10 5.76416C11.3018 5.76416 12.3612 4.70498 12.3612 3.40299C12.3612 2.10098 11.3018 1.04199 10 1.04199Z"
        />
        <path
          fill="#667085"
          d="M11.3888 2.29245C11.3888 2.13887 11.2646 2.01465 11.111 2.01465C11.0338 2.01465 10.9646 2.04603 10.9144 2.09642L10.2776 2.733V1.73678C10.2776 1.5832 10.1534 1.45898 9.99985 1.45898C9.84627 1.45898 9.72205 1.5834 9.72205 1.73678V3.40338C9.72205 3.55696 9.84626 3.68118 9.99985 3.68118C10.0769 3.68118 10.1463 3.6498 10.1965 3.59941L11.3071 2.4892C11.3577 2.43881 11.3888 2.36921 11.3888 2.29245Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8934_16248">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : Props.menuId === constants.MENU_ICON.MOCK ? (
    <svg
      width="19"
      height="20"
      fill="none"
      viewBox="0 0 19 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.8332 8.41732V4.45899C15.8332 3.14731 14.7698 2.08398 13.4582 2.08398H5.54151C4.22983 2.08398 3.1665 3.14731 3.1665 4.45898V15.5423C3.1665 16.854 4.22983 17.9173 5.5415 17.9173H7.12484"
      />
      <path
        stroke="#667085"
        strokeWidth="1.10833"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.5 17.918L11.5456 17.1312C11.6765 17.0809 11.7419 17.0557 11.8031 17.0229C11.8574 16.9937 11.9093 16.96 11.958 16.9222C12.0129 16.8796 12.0625 16.83 12.1616 16.7309L16.3196 12.5729C16.7268 12.1657 16.7268 11.5055 16.3196 11.0984C15.9124 10.6912 15.2523 10.6912 14.8451 11.0983L10.6871 15.2564C10.588 15.3555 10.5384 15.4051 10.4958 15.4599C10.458 15.5087 10.4243 15.5605 10.3951 15.6149C10.3623 15.6761 10.3371 15.7415 10.2868 15.8724L9.5 17.918ZM9.5 17.918L10.2587 15.9454C10.313 15.8043 10.3401 15.7337 10.3867 15.7014C10.4274 15.6731 10.4777 15.6624 10.5264 15.6717C10.582 15.6824 10.6355 15.7358 10.7425 15.8428L11.5752 16.6755C11.6822 16.7825 11.7356 16.8359 11.7463 16.8916C11.7555 16.9403 11.7449 16.9906 11.7166 17.0313C11.6843 17.0779 11.6137 17.105 11.4726 17.1593L9.5 17.918Z"
      />
      <path
        stroke="#667085"
        strokeWidth="1.58333"
        strokeLinecap="round"
        d="M9.104 5.64648L12.6665 5.64648"
      />
      <path
        stroke="#667085"
        strokeWidth="1.58333"
        strokeLinecap="round"
        d="M9.104 8.8125L12.6665 8.8125"
      />
      <path
        stroke="#667085"
        strokeWidth="1.58333"
        strokeLinecap="round"
        d="M9.104 11.9805L10.2915 11.9805"
      />
      <path
        stroke="#667085"
        strokeWidth="0.791667"
        strokeLinejoin="round"
        d="M6.33313 5.64583C6.33313 5.86445 6.51035 6.04167 6.72896 6.04167C6.94758 6.04167 7.1248 5.86445 7.1248 5.64583C7.1248 5.42722 6.94758 5.25 6.72896 5.25C6.51035 5.25 6.33313 5.42722 6.33313 5.64583Z"
      />
      <path
        stroke="#667085"
        strokeWidth="0.791667"
        strokeLinejoin="round"
        d="M6.33313 8.8138C6.33313 9.03241 6.51035 9.20964 6.72896 9.20964C6.94758 9.20964 7.1248 9.03241 7.1248 8.8138C7.1248 8.59519 6.94758 8.41797 6.72896 8.41797C6.51035 8.41797 6.33313 8.59519 6.33313 8.8138Z"
      />
      <path
        stroke="#667085"
        strokeWidth="0.791667"
        strokeLinejoin="round"
        d="M6.33325 11.9798C6.33325 12.1984 6.51047 12.3757 6.72909 12.3757C6.9477 12.3757 7.12492 12.1984 7.12492 11.9798C7.12492 11.7612 6.9477 11.584 6.72909 11.584C6.51047 11.584 6.33325 11.7612 6.33325 11.9798Z"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.DOUBTS ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8899_15753)">
        <path
          stroke="#667085"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.575 7.49935C7.77092 6.94241 8.15762 6.47277 8.66663 6.17363C9.17563 5.87448 9.77408 5.76513 10.356 5.86494C10.9379 5.96475 11.4657 6.26729 11.8459 6.71896C12.2261 7.17063 12.4342 7.74228 12.4333 8.33268C12.4333 9.99935 9.93333 10.8327 9.93333 10.8327M10 14.166H10.0083M18.3333 9.99935C18.3333 14.6017 14.6024 18.3327 10 18.3327C5.39762 18.3327 1.66666 14.6017 1.66666 9.99935C1.66666 5.39698 5.39762 1.66602 10 1.66602C14.6024 1.66602 18.3333 5.39698 18.3333 9.99935Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8899_15753">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : Props.menuId === constants.MENU_ICON.NOTIFICATION ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.79515 17.4993C8.38276 18.018 9.15463 18.3327 10 18.3327C10.8454 18.3327 11.6172 18.018 12.2049 17.4993M15 6.66602C15 5.33993 14.4732 4.06816 13.5355 3.13048C12.5979 2.1928 11.3261 1.66602 10 1.66602C8.67392 1.66602 7.40215 2.1928 6.46447 3.13048C5.52679 4.06816 5 5.33993 5 6.66602C5 9.24117 4.35039 11.0043 3.62472 12.1705C3.01261 13.1542 2.70655 13.6461 2.71777 13.7833C2.7302 13.9352 2.76239 13.9932 2.88482 14.084C2.99539 14.166 3.49383 14.166 4.49071 14.166H15.5093C16.5062 14.166 17.0046 14.166 17.1152 14.084C17.2376 13.9932 17.2698 13.9352 17.2822 13.7833C17.2935 13.6461 16.9874 13.1542 16.3753 12.1705C15.6496 11.0043 15 9.24117 15 6.66602Z"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.ISSUE ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8934_16080)">
        <path
          stroke="#FF0000"
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10 6.66602V9.99935M10 13.3327H10.0083M1.66667 7.10163V12.8971C1.66667 13.1009 1.66667 13.2028 1.6897 13.2987C1.71011 13.3837 1.74378 13.465 1.78947 13.5396C1.84101 13.6237 1.91307 13.6957 2.0572 13.8399L6.15948 17.9422C6.30361 18.0863 6.37567 18.1583 6.45977 18.2099C6.53433 18.2556 6.61562 18.2892 6.70065 18.3097C6.79655 18.3327 6.89846 18.3327 7.10229 18.3327H12.8977C13.1015 18.3327 13.2035 18.3327 13.2994 18.3097C13.3844 18.2892 13.4657 18.2556 13.5402 18.2099C13.6243 18.1583 13.6964 18.0863 13.8405 17.9422L17.9428 13.8399C18.0869 13.6957 18.159 13.6237 18.2105 13.5396C18.2562 13.465 18.2899 13.3837 18.3103 13.2987C18.3333 13.2028 18.3333 13.1009 18.3333 12.8971V7.10163C18.3333 6.89781 18.3333 6.7959 18.3103 6.69999C18.2899 6.61496 18.2562 6.53367 18.2105 6.45911C18.159 6.37501 18.0869 6.30295 17.9428 6.15882L13.8405 2.05654C13.6964 1.91241 13.6243 1.84035 13.5402 1.78882C13.4657 1.74312 13.3844 1.70945 13.2994 1.68904C13.2035 1.66602 13.1015 1.66602 12.8977 1.66602H7.10229C6.89846 1.66602 6.79655 1.66602 6.70065 1.68904C6.61562 1.70945 6.53433 1.74312 6.45977 1.78882C6.37567 1.84035 6.30361 1.91241 6.15948 2.05654L2.0572 6.15882C1.91307 6.30295 1.84101 6.37501 1.78947 6.45911C1.74378 6.53367 1.71011 6.61496 1.6897 6.69999C1.66667 6.7959 1.66667 6.89781 1.66667 7.10163Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8934_16080">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : Props.menuId === constants.MENU_ICON.PROFILE ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.6667 17.5C16.6667 16.337 16.6667 15.7555 16.5231 15.2824C16.2 14.217 15.3663 13.3834 14.3009 13.0602C13.8278 12.9167 13.2463 12.9167 12.0833 12.9167H7.91667C6.75369 12.9167 6.17221 12.9167 5.69904 13.0602C4.63371 13.3834 3.80003 14.217 3.47686 15.2824C3.33333 15.7555 3.33333 16.337 3.33333 17.5M13.75 6.25C13.75 8.32107 12.0711 10 9.99999 10C7.92893 10 6.24999 8.32107 6.24999 6.25C6.24999 4.17893 7.92893 2.5 9.99999 2.5C12.0711 2.5 13.75 4.17893 13.75 6.25Z"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.NOTICEBOARD ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 
20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 
22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 
19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 
4 7.07003 4 8 4M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 
4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 
14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 
4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z" stroke="#667085" 
stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  ) : Props.menuId === constants.MENU_ICON.LOGOUT ? (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#667085"
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.3333 14.1663L17.5 9.99961M17.5 9.99961L13.3333 5.83294M17.5 9.99961H7.5M10 14.1663C10 14.4126 10 14.5357 9.99085 14.6424C9.89569 15.7512 9.07905 16.6636 7.98753 16.8807C7.88252 16.9015 7.76001 16.9152 7.51529 16.9424L6.66412 17.0369C5.3854 17.179 4.74601 17.25 4.23805 17.0875C3.56078 16.8708 3.00785 16.3759 2.71765 15.7267C2.5 15.2398 2.5 14.5965 2.5 13.3099V6.68935C2.5 5.40274 2.5 4.75944 2.71765 4.27254C3.00785 3.62334 3.56078 3.12844 4.23805 2.91171C4.74601 2.74916 5.38538 2.8202 6.66412 2.96229L7.51529 3.05686C7.7601 3.08406 7.8825 3.09766 7.98753 3.11854C9.07905 3.33557 9.89569 4.24797 9.99085 5.35678C10 5.46347 10 5.58662 10 5.83294"
      />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.CC ? (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9395 0L14.0086 0.444445L10.0605 20L7.99136 19.5556L11.9395 0ZM19.0125 10L15.2226 6.01111V2.86667L22 10L15.2226 17.1222V13.9778L19.0125 10ZM0 10L6.77735 2.86667V6.01111L2.98752 10L6.77735 13.9778V17.1222L0 10Z" fill="#F96343" />
    </svg>
  ) : Props.menuId === constants.MENU_ICON.DASHBOARD ? (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.91 5.68774H8.77252C8.63992 5.68774 8.51275 5.74042 8.41897 5.83419C8.3252 5.92794 8.27252 6.05512 8.27252 6.18774V13.8927C8.27292 14.0252 8.32572 14.1522 8.4194 14.2458C8.5131 14.3395 8.64005 14.3923 8.77252 14.3927H13.91C14.0425 14.3923 14.1694 14.3395 14.2631 14.2458C14.3568 14.1522 14.4096 14.0252 14.41 13.8927V6.18774C14.41 6.05512 14.3573 5.92794 14.2636 5.83419C14.1698 5.74042 14.0426 5.68774 13.91 5.68774Z" fill="#B21E00" />
    <path d="M13.91 1.40674H8.77252C8.63992 1.40674 8.51275 1.45942 8.41897 1.55319C8.3252 1.64695 8.27252 1.77413 8.27252 1.90674V4.47423C8.27292 4.60673 8.32572 4.73368 8.4194 4.82735C8.5131 4.92103 8.64005 4.97385 8.77252 4.97423H13.91C14.0425 4.97385 14.1694 4.92103 14.2631 4.82735C14.3568 4.73368 14.4096 4.60673 14.41 4.47423V1.90674C14.41 1.77413 14.3573 1.64695 14.2636 1.55319C14.1698 1.45942 14.0426 1.40674 13.91 1.40674Z" fill="white" />
    <path d="M7.05999 9.11279H1.92499C1.64885 9.11279 1.42499 9.33667 1.42499 9.61279V13.8928C1.42499 14.1689 1.64885 14.3928 1.92499 14.3928H7.05999C7.33614 14.3928 7.55999 14.1689 7.55999 13.8928V9.61279C7.55999 9.33667 7.33614 9.11279 7.05999 9.11279Z" fill="white" />
    <path d="M7.05999 1.40674H1.92499C1.85927 1.40651 1.79414 1.41928 1.73337 1.44433C1.67261 1.46938 1.6174 1.50619 1.57092 1.55267C1.52444 1.59914 1.48762 1.65435 1.46257 1.71512C1.43753 1.77589 1.42476 1.84101 1.42499 1.90674V7.88925C1.42499 8.02185 1.47767 8.14902 1.57144 8.2428C1.66521 8.33655 1.79238 8.38925 1.92499 8.38925H7.05999C7.19259 8.38925 7.31976 8.33655 7.41354 8.2428C7.50731 8.14902 7.55999 8.02185 7.55999 7.88925V1.90674C7.56021 1.84101 7.54744 1.77589 7.52239 1.71512C7.49736 1.65435 7.46054 1.59914 7.41406 1.55267C7.36759 1.50619 7.31236 1.46938 7.25161 1.44433C7.19084 1.41928 7.12571 1.40651 7.05999 1.40674Z" fill="#B21E00" />
  </svg>) :  Props.menuId === constants.MENU_ICON.COMPANY_SPECIFIC ? (
    <svg width="19" height="20" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.41667 6.08333H2.48333C2.10996 6.08333 1.92328 6.08333 1.78067 6.156C1.65523 6.21991 1.55324 6.3219 1.48933 6.44734C1.41667 6.58995 1.41667 6.77663 1.41667 7.15V12.75M10.4167 6.08333H12.35C12.7234 6.08333 12.9101 6.08333 13.0527 6.156C13.1781 6.21991 13.2801 6.3219 13.344 6.44734C13.4167 6.58995 13.4167 6.77663 13.4167 7.15V12.75M10.4167 12.75V2.88333C10.4167 2.1366 10.4167 1.76323 10.2713 1.47801C10.1435 1.22713 9.93954 1.02316 9.68865 0.895325C9.40344 0.75 9.03007 0.75 8.28333 0.75H6.55C5.80326 0.75 5.42989 0.75 5.14468 0.895325C4.8938 1.02316 4.68982 1.22713 4.56199 1.47801C4.41667 1.76323 4.41667 2.1366 4.41667 2.88333V12.75M14.0833 12.75H0.75M6.75 3.41667H8.08333M6.75 6.08333H8.08333M6.75 8.75H8.08333" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  ) : Props.menuId === constants.MENU_ICON.TECHNOLOGY_SPECIFIC ? (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6976_6631)">
<path d="M6.0013 0.666626V2.66663M10.0013 0.666626V2.66663M6.0013 13.3333V15.3333M10.0013 13.3333V15.3333M13.3346 5.99996H15.3346M13.3346 9.33329H15.3346M0.667969 5.99996H2.66797M0.667969 9.33329H2.66797M4.0013 2.66663H12.0013C12.7377 2.66663 13.3346 3.26358 13.3346 3.99996V12C13.3346 12.7363 12.7377 13.3333 12.0013 13.3333H4.0013C3.26492 13.3333 2.66797 12.7363 2.66797 12V3.99996C2.66797 3.26358 3.26492 2.66663 4.0013 2.66663ZM6.0013 5.99996H10.0013V9.99996H6.0013V5.99996Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_6976_6631">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
) : Props.menuId === constants.MENU_ICON.VIDEO ? (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6654 5.95417C14.6654 5.55029 14.6654 5.34835 14.5855 5.25484C14.5162 5.1737 14.4122 5.13065 14.3059 5.13902C14.1833 5.14867 14.0405 5.29146 13.7549 5.57704L11.332 7.99992L13.7549 10.4228C14.0405 10.7084 14.1833 10.8512 14.3059 10.8608C14.4122 10.8692 14.5162 10.8261 14.5855 10.745C14.6654 10.6515 14.6654 10.4495 14.6654 10.0457V5.95417Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.33203 6.53325C1.33203 5.41315 1.33203 4.85309 1.55002 4.42527C1.74176 4.04895 2.04773 3.74299 2.42405 3.55124C2.85187 3.33325 3.41193 3.33325 4.53203 3.33325H8.13203C9.25214 3.33325 9.81219 3.33325 10.24 3.55124C10.6163 3.74299 10.9223 4.04895 11.114 4.42527C11.332 4.85309 11.332 5.41315 11.332 6.53325V9.46658C11.332 10.5867 11.332 11.1467 11.114 11.5746C10.9223 11.9509 10.6163 12.2569 10.24 12.4486C9.81219 12.6666 9.25214 12.6666 8.13203 12.6666H4.53203C3.41193 12.6666 2.85187 12.6666 2.42405 12.4486C2.04773 12.2569 1.74176 11.9509 1.55002 11.5746C1.33203 11.1467 1.33203 10.5867 1.33203 9.46658V6.53325Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

):(
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className="menuSvgIconForInterview"
    >
      <path
        fill="#667085"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0498 0.152665C15.0071 0.261192 14.9122 0.521375 14.8388 0.730772C14.6508 1.26729 14.4122 1.64935 14.0295 2.02663C13.6176 2.43278 13.2762 2.63396 12.5812 2.87995C12.2818 2.98595 12.0368 3.11021 12.0368 3.15608C12.0368 3.20195 12.2186 3.29657 12.4407 3.36625C13.721 3.76797 14.3403 4.34552 14.8511 5.6144C14.9902 5.96 15.1352 6.25306 15.1733 6.26577C15.2114 6.27849 15.3313 6.03404 15.4397 5.72258C15.8425 4.56538 16.4688 3.91099 17.5854 3.4804C17.8924 3.36204 18.1761 3.26517 18.216 3.26517C18.2558 3.26517 18.2885 3.22183 18.2885 3.16893C18.2885 3.11232 18.0648 2.99325 17.746 2.88002C16.4972 2.43671 15.8117 1.71973 15.3784 0.403576C15.2307 -0.0450717 15.1512 -0.105762 15.0498 0.152665ZM7.75206 3.91492C7.71519 4.00182 7.52616 4.5049 7.33208 5.03278C6.78312 6.52589 6.21794 7.3986 5.31446 8.14817C4.65213 8.69769 4.0297 9.0272 2.78217 9.48877C1.48329 9.96931 1.44009 10.0383 2.25534 10.3288C3.93368 10.9271 4.57599 11.2522 5.3283 11.8847C6.27533 12.6809 6.83032 13.5661 7.43295 15.2417C7.61361 15.744 7.79112 16.1852 7.82737 16.2221C7.94594 16.3429 8.08095 16.1066 8.38749 15.2417C8.95323 13.6456 9.41031 12.8995 10.371 12.004C11.048 11.3729 11.7145 11.0001 12.9762 10.5468C13.5409 10.3439 14.0413 10.1395 14.0881 10.0927C14.2274 9.95337 14.0413 9.84189 13.1256 9.51673C11.5945 8.9729 11.1125 8.70633 10.3194 7.96441C9.40392 7.108 8.94164 6.34592 8.38517 4.77541C8.00859 3.71241 7.90042 3.56546 7.75206 3.91492ZM15.0581 13.8895C15.0215 13.9765 14.9119 14.2498 14.8145 14.4968C14.3589 15.6522 13.6905 16.2588 12.4407 16.6509C12.2186 16.7206 12.0368 16.8152 12.0368 16.8611C12.0368 16.9069 12.2818 17.0312 12.5812 17.1372C13.8333 17.5804 14.4139 18.1493 14.8694 19.3789C14.992 19.7101 15.1228 19.9895 15.16 19.9997C15.1972 20.01 15.3277 19.7473 15.4499 19.4161C15.714 18.7003 15.9199 18.3632 16.332 17.9718C16.7474 17.5772 17.1123 17.3621 17.7502 17.1357C18.0662 17.0234 18.2885 16.9048 18.2885 16.8482C18.2885 16.7953 18.2558 16.752 18.216 16.752C18.1761 16.752 17.8924 16.6551 17.5854 16.5368C16.4693 16.1064 15.8425 15.4517 15.4403 14.2962C15.3321 13.9856 15.2169 13.7315 15.1841 13.7315C15.1513 13.7315 15.0947 13.8026 15.0581 13.8895Z"
      />
    </svg>
  );
}
